import React, { useMemo } from 'react';
import { QRCode } from 'antd';
import type { QRCodeProps as AntQRCodeProps } from 'antd';
import { useAndStore } from '../../base/store/useAndStore';
import { getDataSetStoreKey } from '../../base/storeKeyUtils';
import type { BaseComponentProps, DataSetConfig } from '../../types/common';

export interface AndQRCodeProps extends AntQRCodeProps, BaseComponentProps, DataSetConfig {}

export const AndQRCode: React.FC<AndQRCodeProps> = ({
  id, sessionId, develop, dataSet, dataSetField, value: propValue, ...restProps
}) => {
  const getDataSet = useAndStore((state) => state.getDataSet);
  const getProps = useAndStore((state) => state.getProps);
  const dataSetKey = useMemo(
    () => getDataSetStoreKey(sessionId, dataSet),
    [sessionId, dataSet]
  );

  const storeProps = useMemo(() => {
    if (sessionId && id) return getProps(sessionId, id);
    return null;
  }, [sessionId, id, getProps]);

  const storeValue = useMemo(() => {
    if (dataSetKey && dataSetField) return getDataSet(dataSetKey, dataSetField);
    return undefined;
  }, [dataSetKey, dataSetField, getDataSet]);

  // value 绑定
  const computedValue = useMemo(() => {
    if (develop) return propValue;
    if (storeValue !== undefined && storeValue !== null && storeValue !== '') {
      return String(storeValue);
    }
    if (storeProps?.value !== undefined) return storeProps.value;
    return propValue;
  }, [develop, storeValue, storeProps?.value, propValue]);

  const mergedProps = useMemo(() => {
    const baseProps = { ...restProps };
    if (storeProps && typeof storeProps === 'object') {
      Object.keys(storeProps).forEach((key) => {
        if (key !== 'value' && storeProps[key] !== undefined && storeProps[key] !== null) {
          (baseProps as any)[key] = storeProps[key];
        }
      });
    }
    return baseProps;
  }, [restProps, storeProps]);

  return <QRCode {...mergedProps} value={computedValue || ''} />;
};

export default AndQRCode;

